import { Routes } from '@angular/router';
import { riskManagerGuard } from '@core/guards/risk-manager.guard';

export const auditRoutes: Routes = [
  {
    path: 'audit',
    loadComponent: () => import('./audit.component').then(m => m.AuditComponent),
    canActivate: [riskManagerGuard],
  },
];
